import { Component, OnDestroy } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { PasswordService } from '../../services';
import { Router } from '@angular/router';
import { SubSink } from 'subsink';

@Component({
  selector: 'omn-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnDestroy {

  logoSrc: string = '';

  form: FormGroup;

  sent = false;

  private readonly subs = new SubSink();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private readonly passwordService: PasswordService
  ) {
    this.logoSrc = environment.logoSrc;
    this.form = this.fb.group({
      username: ['', [Validators.required]]
    });
  }

  get username(): AbstractControl {
    return this.form.get('username')!;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  submit(): void {
    if (this.form.valid) {
      const username = this.username?.value.toLowerCase();
      this.passwordService.reset(username)
        .subscribe(() => this.sent = true);
    }
  }

}